import React, { useState } from "react";

const TypeOfAutomation = ({ onNext, data, handlePrevious }) => {
  const [selectedType, setSelectedType] = useState(data?.type || "DM");
  const [loading, setLoading] = useState(false);

  // Sync state when data prop changes (e.g., when navigating back)
  React.useEffect(() => {
    if (data?.type !== undefined) {
      setSelectedType(data.type || "DM");
    }
  }, [data?.type]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    onNext({ typeOfAutomation: { type: selectedType } });
    setLoading(false);
  };

  return (
    <div>
      <h1 className="text-xl font-semibold mb-6">Type of Automation</h1>
      <p className="text-gray-600 mb-6">
        Select the type of automation you want to create.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* DM Option */}
        <label className="flex items-center space-x-3 cursor-pointer">
          <input
            type="radio"
            name="automationType"
            value="DM"
            checked={selectedType === "DM"}
            onChange={(e) => setSelectedType(e.target.value)}
            className="w-4 h-4 text-orange-600 focus:ring-orange-500"
          />
          <span className="text-gray-800">DM</span>
        </label>

        {/* Comments Option (Disabled) */}
        <label className="flex items-center space-x-3 cursor-not-allowed opacity-50">
          <input
            type="radio"
            name="automationType"
            value="Comments"
            disabled
            className="w-4 h-4 text-orange-600"
          />
          <span>Comments</span>
        </label>

        {/* Both Option (Disabled) */}
        <label className="flex items-center space-x-3 cursor-not-allowed opacity-50">
          <input
            type="radio"
            name="automationType"
            value="Both"
            disabled
            className="w-4 h-4 text-orange-600"
          />
          <span>Both</span>
        </label>

        {/* Buttons */}
        <div className="flex justify-between pt-6">
          <button
            type="button"
            onClick={handlePrevious}
            className="bg-gray-300 text-gray-800 px-5 py-2 rounded-md hover:bg-gray-400 transition duration-300"
          >
            Back
          </button>

          <button
            type="submit"
            disabled={loading}
            className={`px-5 py-2 rounded-md text-white transition duration-300 ${
              loading
                ? "bg-orange-300 cursor-not-allowed"
                : "bg-orange-500 hover:bg-orange-600"
            }`}
          >
            {loading ? "Saving..." : "Next"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TypeOfAutomation;
